import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  createNewCourse: {
    id: 'course-authoring.studio-home.new-course.title',
    defaultMessage: 'Create a new course',
  },
});

export default messages;
